import debounce from 'lodash.debounce'
import { useCallback } from 'react'

// biome-ignore lint/suspicious/noExplicitAny: boundary type, narrowed by callers
export const useDebouncedCallback = <T extends (...args: any[]) => void>(
  callback: T,
  delay: number,
): ((...args: Parameters<T>) => void) => {
  return useCallback(debounce<T>(callback, delay), [])
}
